const Avatar = () => {
    return (
        <img src={process.env.PUBLIC_URL + "/defaultAvatar.png"} alt="Avatar" />
    )
}

export default Avatar;